import { Component, Inject } from '@angular/core';
import { SabisNgxDialogComponent } from '../../sabis-dialog/dialog.component';
import { SabisNgxDatepickerComponent } from '../../sabis-datepicker/datepicker.component';
import { SabisNgxFilePickerComponent } from '../../file-picker/file-picker.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileChangedEvent } from '../../file-picker/file-picker.component';
import { ModalArgs, ModalInput, ModalResult, ModalType } from '../models';
import { FormsModule } from '@angular/forms';
import { SabisButton2Component } from '../../sabis-button2/sabis-button2.component';
import { SabisInput2Component } from '../../sabis-input2/input.component';
import { SabisTextArea2Component } from '../../sabis-textarea2/text-area.component';

@Component({
  selector: 'sabis-ngx-modal-dialog',
  templateUrl: './inputs-dialog.component.html',
  styleUrls: ['./inputs-dialog.component.scss'],
  imports: [
    FormsModule,
    SabisButton2Component,
    SabisInput2Component,
    SabisTextArea2Component,
    SabisNgxDatepickerComponent,
    SabisNgxFilePickerComponent,
    SabisNgxDialogComponent
  ]
})
export class SabisNgxModalDialogComponent {
  public title: string = 'Modal Title';
  public type: 'notification' | 'alert' = 'notification';
  public messages: string[] = [];
  public buttons: ActionButton[] = [];
  public parts: ModalInput[] = [];

  private _receivedData: ModalDialogArgs;
  private _values: { [key: string]: any } = [];

  constructor(
    public dialogRef: MatDialogRef<SabisNgxModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalDialogArgs
  ) {
    this._receivedData = data;
    this.title = data.title;
    this.type = data.type === ModalType.Alert ? 'alert' : 'notification';
    this.messages = (typeof data.message === 'string') ? [data.message] : data.message;
    this.parts = data.inputs;

    // set action buttons
    this.buttons.push({ name: this._receivedData.confirmButtonName, result: true });
    this.buttons.push({ name: this._receivedData.discardButtonName, result: false });

    // set initial values
    this._receivedData.inputs.filter(i => i.type !== 'file').forEach(i => {
      this._values[i.name] = i.value;
    });
  }

  public onModelChange(value: any, part: ModalInput): void {
    if (part.type === 'file') {
      let eventValue: FileChangedEvent = value;
      // 1st change event
      if (!this._values[part.name]) {
        this._values[part.name] = [];
      }

      // remove if removed and new
      if (eventValue.isRemoved) {
        // new => remove from events
        if (eventValue.uploadResult) {
          this._values[part.name] = this._values[part.name].filter((file: FileChangedEvent) => file.id !== eventValue.id);
        }
        // old => keep
        else {
          this._values[part.name].push(eventValue);
        }
      }
      // add if new
      else {
        this._values[part.name].push(eventValue);
      }
    }
    else {
      this._values[part.name] = value;
    }
  }

  public onActionButtonClick(button: ActionButton): void {
    let result: ModalResult = {
      confirmed: button.result,
      inputsValue: this._values
    };

    this.data.onActionCallback(result).subscribe(r => {
      if (r) {
        this.dialogRef.close(result);
      }
    });
  }
}

/** params neede to open this dialog (same as the ones received by the service) */
export interface ModalDialogArgs extends ModalArgs {

}

interface ActionButton {
  result: boolean;
  name: string;
  cssClass?: string;
}
